module.exports = __webpack_public_path__ + "assets/media/mike_face.26dc4c51.png";